<template>
  <div>
    <Header :title="flag ? '课程签退' : '课程签到'"></Header>
    <div class="detail">
      <h4>{{ decodeURIComponent(detailList[3]) }}</h4>
      <p>
        <i class="icon1"></i><span>教师：</span
        >{{ decodeURIComponent(detailList[4]) }}
      </p>
      <p>
        <i class="icon2"></i><span>教室：</span
        >{{ decodeURIComponent(detailList[5]) }}
      </p>
      <p>
        <i class="icon3"></i><span>本课时间：</span
        >{{ decodeURIComponent(detailList[9]) }}节，{{ detailList[6] }} -
        {{ detailList[7] }}
      </p>
      <p><i class="icon4"></i><span>教学周：</span>第{{ detailList[8] }}周</p>
    </div>
    <div class="stu-info">
      <input
        type="text"
        :readonly="schoolCode == '12928' ? true : false"
        v-model="studentNum"
        placeholder="请输入你的学号"
        @click="show()"
      />
      <div class="question" v-if="flag&&!iszt">
        <p>你认为本次课任课教师授课质量为（单选）：</p>
        <van-radio-group v-model="radio" direction="horizontal">
          <van-radio name="A">A.好</van-radio>
          <van-radio name="B">B.中</van-radio>
          <van-radio name="C">C.差</van-radio>
        </van-radio-group>
      </div>
    </div>
     <!--{{ info }}-->
    <button class="sign-btn" @click="signTap()">
      {{ flag ? "签退" : "签到" }}
    </button>
  </div>
</template>
<script>
import { Api } from "../../../utils/axios";
export default {
  data() {
    return {
      detailList:[],
      studentNum: "",
      student_token:"",
      radio: "",
      flag: false,
      schoolCode: "",
      kbid:"",
      kqKeyScret:"",
        kcjssj:"",
        iszt:false
     // info: {}
    };
  },
  created() {
    this.detailList = this.$route.query.course.split("*@*");
    this.kqKeyScret = this.$route.query.scrStr;
    this.kbid = decodeURIComponent(this.detailList[0]);
    this.schoolCode = this.$route.query.schoolCode;
    this.flag = this.$route.query.type == "qd" ? false : true;
    if (this.schoolCode=="14128") {
      this.student_token = this.$route.query.token;
      this.kcjssj=this.$route.query.kcjssj;
      if(Math.round(new Date())<this.kcjssj){
          this.iszt = true;
      }
      this.getUname();
       //if(!!navigator.userAgent && navigator.userAgent.indexOf("android")>0){
        // jsBridge.setDevice("android")
       //}

    }else if(this.schoolCode=="12928"){
      this.studentNum = this.$route.query.studentId;
    }
    //this.student_token = this.$route.query.token;
    //this.getUname();
    //console.log("kbid:"+this.kbid);
    //this.getSingemess();
  },
  methods: {
    show() {
      if (this.studentNum == ""&&this.schoolCode=="12928") {
        this.$toast.fail("请使用学习通扫码签到！");
      }
    },
   async getUname(){
      //var that = this;
      //jsBridge.bind("CLIENT_GET_USERINFO", function(object) {
       // for (let item of object.unitConfigInfos) {
          //if (item.fid == "170642") {
            //that.studentNum = item.uname;
          //}
        //}
        // that.info = JSON.stringify(object);
     // });
       //jsBridge.postNotification("CLIENT_GET_USERINFO", { accountKey: "" });
       const params = {
         attendanceToken:this.student_token,
       };
        const res = await Api.getStudentAccount(params);
        if(res&&res.studentAccount){
          this.studentNum = res.studentAccount;
        }
    },
    async getSingemess(){
       const params = {
         jx0408id:this.kbid,
       };
        const res = await Api.getSingMessData(params);
        if(res&&res.data){
          this.detailList = res.data;
        }
    },
    signTap() {
      if (this.studentNum == "") {
        if (this.schoolCode == "12928") {
          this.$toast.fail("请使用学习通扫码签到！");
        } else {
          this.$toast.fail("请填写学号");
        }
      } else {
        this.saveTap();
      }
    },
    async saveTap() {
      if (this.flag&&!this.iszt) {
        if (this.radio == "") {
          this.$toast.fail("请选择本次课任课教师授课质量！");
          return;
        }
      }

      const params = {
        jx0408id: this.detailList[0],
        zc: this.$route.query.week,
        xq: this.detailList[1],
        jc: this.detailList[2],
        xh: this.studentNum,
        isdqrq: this.$route.query.isdqrq,
        pj: this.radio,
        time: this.$route.query.time,
        type: this.$route.query.type,
        keyCret : this.kqKeyScret,
        jsxm:decodeURIComponent(this.detailList[4])
      };
      const res = await Api.checkWorkAttendanceSaveXsqd(params);
      if (res.code == "0") {
        this.$toast.fail(res.Msg);
      } else {
        this.$toast.success(res.Msg);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.detail {
  padding: 8px 20px;
  color: @attendance-color-1;
  position: relative;
}

.qr-area {
  position: absolute;
  width: 100px;
  height: 49px;
  background: url(../../../../static/img/qr_code.png) no-repeat center;
  background-size: 100%;
  right: 16px;
  top: 51px;
}

.detail > h4 {
  font-size: 24px;
  margin-bottom: 21px;
}

.detail > p {
  display: flex;
  font-weight: 600;
  margin-bottom: 20px;
}

.detail > p > span {
  font-weight: 400;
  color: @attendance-color-2;
}

.detail i {
  width: 22px;
  height: 23px;
  margin-right: 8px;
}

.detail i.icon1 {
  background: url(../../../assets/images/icon_people2.png) no-repeat center;
  background-size: 22px 23px;
}

.detail i.icon2 {
  background: url(../../../assets/images/address_icon2.png) no-repeat center;
  background-size: 22px 23px;
}

.detail i.icon3 {
  background: url(../../../assets/images/time_icon2.png) no-repeat center;
  background-size: 22px 23px;
}

.detail i.icon4 {
  background: url(../../../assets/images/date_icon2.png) no-repeat center;
  background-size: 22px 23px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.stu-info {
  margin: 0px 20px;
}

.stu-info > input {
  background-color: @attendance-background-color-6;
  width: 100%;
  padding: 11px 13px;
  box-sizing: border-box;
  border-radius: 3px;
  color: @attendance-color-1;
  margin-bottom: 20px;
}
.stu-info .question {
  color: #212f6e;
  font-weight: 600;
}
.stu-info .question p {
  margin-bottom: 20px;
}
.sign-btn {
  background-color: @attendance-background-color-1;
  padding: 11px 13px;
  box-sizing: border-box;
  border-radius: 3px;
  color: @attendance-color-3;
  width: 90% !important;
  position: relative;
  left: 20px;
  top: 150px;
}

.sign-btn:active {
  background-color: rgba(116, 105, 248, 0.8);
}
</style>



// WEBPACK FOOTER //
// src/components/student/Attendance/attendanceRate_qzzyjsdx.vue